import { StatusCodes } from "http-status-codes"
import { useContext, useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { digitalManagerApi } from "../../../../../../../services/api"
import { renderApplicationRoleApproverContainer } from "../../../../../../components/Helpers"
import { UserContext } from "../../../../../../context/UserContext"
import { ApplicationRoleApproverGet } from "../../../../../../models/ApplicationRoleApprover"
import { useHashTab } from "../../../../../../../hooks/useHashTab"
import { ApplicationRoleApproverPropertyDetails } from "./details_tab/ApplicationRoleApproverPropertyDetails"

export const ApplicationRoleApproverPropertyContainer = () => {
  const { applicationId, roleId, userId, propertyName, propertyValue } =
    useParams()
  const { user, isLoadingUser } = useContext(UserContext)
  const navigate = useNavigate()

  const { activeTab, handleTabChange } = useHashTab("details")

  const [approver, setApprover] = useState<ApplicationRoleApproverGet>()

  const returnURL = `/applications/${applicationId}/roles/${roleId}/approvers/${userId}#properties`

  useEffect(() => {
    if (applicationId && roleId && userId && propertyName && propertyValue) {
      digitalManagerApi
        .get(
          `/applications/${applicationId}/roles/${roleId}/approvers/${userId}/properties/${propertyName}/values/${propertyValue}`
        )
        .then((res) => {
          if (res.status === StatusCodes.OK) {
            setApprover(res.data)
          }
        })
        .catch(() => {
          navigate(returnURL)
        })
    }
  }, [applicationId, navigate, propertyName, propertyValue, returnURL, roleId, userId])

  return renderApplicationRoleApproverContainer({
    returnURL,
    approver,
    isLoadingUser,
    user,
    activeTab,
    handleTabChange,
    hasRequiredParams: Boolean(applicationId && roleId && userId),
    tabItems: [{ id: "details", label: "Details" }],
    detailsContent: activeTab === "details" && approver && user && (
      <ApplicationRoleApproverPropertyDetails
        approver={approver}
        user={user}
        setApprover={setApprover}
      />
    ),
  })
}
